import * as React from "react";
import { useEffect, useState } from "react";
import { Box, Button, List, ListItem, ListItemSecondaryAction, ListItemText, TextField } from "@material-ui/core";
import { useNotify } from "react-admin";
import { cloError, cloGet, ENDPOINTS } from "./api";

export interface Candidate {
  id: number;
  name: string;
}

interface Props {
  picked: number[];
  onPick: (candidate: Candidate) => void;
}

const CandidateSearch: React.FC<Props> = ({ picked, onPick }) => {
  const notify = useNotify();
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    if (search.trim().length < 2) {
      setRows([]);
      return;
    }
    const t = setTimeout(async () => {
      try {
        const res = await cloGet(ENDPOINTS.CLO_MERCHANT_CANDIDATES, { search: search.trim() });
        setRows(res.data || []);
      } catch (e) {
        notify(cloError(e), "warning");
      }
    }, 300);
    return () => clearTimeout(t);
  }, [search, notify]);

  return (
    <Box>
      <TextField
        fullWidth
        margin="dense"
        label="Search enabled brands"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        helperText="Type at least 2 letters"
      />
      {rows.length > 0 && (
        <List dense>
          {rows.map((r) => {
            const added = picked.includes(r.id);
            return (
              <ListItem key={r.id}>
                <ListItemText
                  primary={r.name}
                  secondary={r.clo_merchant_id && !added ? `${r.provider_name} · already linked to merchant ${r.clo_merchant_id}` : r.provider_name}
                />
                <ListItemSecondaryAction>
                  <Button size="small" color="primary" disabled={added || Boolean(r.clo_merchant_id)} onClick={() => onPick({ id: r.id, name: r.name })}>
                    {added ? "Added" : "Add"}
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      )}
    </Box>
  );
};

export default CandidateSearch;
